import type { GatsbyBrowser } from "gatsby";

// Self-hosted variable fonts — no external font requests.
import "@fontsource-variable/space-grotesk";
import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";

import "./src/styles/global.css";

import { RootProviders } from "./src/components/layout/root-providers";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <RootProviders>{element}</RootProviders>;
